import { IParameter } from "../types";
import { buildFetch, buildRequestBody } from "../utils";
import { getParamsGET_FORECAST_JSON, getParamsGET_POINTS_JSON, getParamsGET_R_PARTS, getParamsGET_ROUTES_LISTS } from "./params";
import { IGetParamsGET_FORECAST_JSON, IResponseGET_FORECAST_JSON, IResponseGET_POINTS_JSON, IResponseGET_R_PARTS, IResponseGET_ROUTES_LISTS, IResponseGET_SCHEDULE_AND_FA_LIST } from "./types";

const apiRoadmaps = {
    /** получить маршруты на остановке */
    async get(params: IGetParamsGET_FORECAST_JSON): Promise<IResponseGET_FORECAST_JSON> {
        try {
            const parameters: IParameter[] = getParamsGET_FORECAST_JSON(params);
            if (!params.NCITY_ID) {
                throw new Error("NCITY_ID is a required parameter");
            }
            const body = buildRequestBody({ parameters, city_id: params.NCITY_ID.toString(), object_name: "GET_FORECAST_JSON" });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching bus stations:', error);
            throw new Error('Failed to fetch bus stations. Please try again later.');
        }
    },

    async getPoints(roadmapId: string, cityId: string): Promise<IResponseGET_POINTS_JSON> {
        try {
            if (!roadmapId) {
                throw new Error("roadmapId is a required parameter");
            }
            const parameters: IParameter[] = getParamsGET_POINTS_JSON(roadmapId);
            const body = buildRequestBody({ parameters, city_id: cityId.toString(), object_name: "GET_POINTS_JSON" });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching:', error);
            throw new Error('Failed to fetch. Please try again later.');
        }
    },

    async getByCity(cityId: string): Promise<IResponseGET_ROUTES_LISTS> {
        try {
            if (!cityId) {
                throw new Error("cityId is a required parameter");
            }
            const parameters: IParameter[] = getParamsGET_ROUTES_LISTS();
            const body = buildRequestBody({ parameters, city_id: cityId.toString(), object_name: "GET_ROUTES_LISTS" });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching:', error);
            throw new Error('Failed to fetch. Please try again later.');
        }
    },

    async getRoadmapsDirections(NRL_ID: number, cityId: string, dDATE: string): Promise<IResponseGET_R_PARTS> {
        try {
            if (!NRL_ID) {
                throw new Error("NRL_ID is a required parameter");
            }
            const parameters: IParameter[] = getParamsGET_R_PARTS(NRL_ID, dDATE);
            const body = buildRequestBody({ parameters, city_id: cityId.toString(), object_name: "GET_R_PARTS" });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching:', error);
            throw new Error('Failed to fetch. Please try again later.');
        }
    },

    /** Маршруты между городами и остановками */
    async getScheduleAndFAList(
        date: string,
        firstStop: number | string,
        lastStop: number | string,
        token: string | undefined,
        type: 'busStaition' | 'city',
        cityId: string,
    ): Promise<IResponseGET_SCHEDULE_AND_FA_LIST> {
        try {
            if (!date || !firstStop || !lastStop || !type) {
                const missingParams = [];
                if (!date) missingParams.push("date");
                if (!firstStop) missingParams.push("firstStop");
                if (!lastStop) missingParams.push("lastStop");
                if (!type) missingParams.push("type");

                throw new Error(`All parameters are required. Missing: ${missingParams.join(", ")}`);
            }

            const formatter = new Intl.DateTimeFormat("ru-RU", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            });
            //const formattedDate = formatter.format(new Date(date ?? new Date()));

            const parameters: IParameter[] = [
                { name: "CUSERNAME", value: "" },
                { name: "CPASSW", value: "" },
                { name: "CTOKEN", value: token ?? "" },
                { name: "CDATE_SW", value: date },
                { name: "NFIRST_STOP_POINT", value: firstStop },
                { name: "NLAST_STOP_POINT", value: lastStop },
                { name: "NLAST_STOP_POINT_TYPE", value: type === "busStaition" ? "2" : "1" },
                { name: "NFIRST_ROWNUM", value: "1" },
                { name: "NLAST_ROWNUM", value: 2000000 },
                { name: "NMESSAGE_TYPE", value: "-1" }
            ];

            const body = buildRequestBody({
                parameters,
                object_name: "GET_SCHEDULE_AND_FA_LIST",
                city_id: `${cityId}`
            });

            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error("Error fetching schedule:", error);
            throw new Error("Failed to fetch schedule. Please try again later.");
        }
    }
};

export default apiRoadmaps;